import loadable from '@loadable/component';

const BlogsPage = loadable(() => import('./BlogsPage'));

export { BlogsPage };
